module.exports = __webpack_public_path__ + "static/media/MT6.a8cb8294.mp3";